import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})


export class PhoneValidationService {
  private libPhone: any;
  private loading?: Promise<any>;

  private async loadLibPhoneNumber() {
    if (this.libPhone) {
      return this.libPhone;
    }

    if (!this.loading) {
      this.loading = import('google-libphonenumber').then((lib) => {
        this.libPhone = lib;
        return lib;
      });
    }

    return this.loading;
  }

  async checkPhone(countryCode: string, phoneNumber: string): Promise<boolean> {
    const libPhone = await this.loadLibPhoneNumber();

    if (phoneNumber?.length < 3) {
      return false;
    }

    const phoneUtil =
      libPhone.PhoneNumberUtil?.getInstance() ??
      libPhone.default.PhoneNumberUtil?.getInstance();

    const number = phoneUtil.parseAndKeepRawInput(
      countryCode + phoneNumber,
      'US'
    );

    return phoneUtil.isValidNumber(number);
  }
}
